/** @jsxImportSource @emotion/react */
import React from 'react';

export default function Main(props: {children?: React.ReactNode, noPadding?: boolean}) {
  const { noPadding, ...rest } = props
  return (
    <div
      css={{
        padding: noPadding ? '0px' : '0px 15px 15px',
        position: 'relative',
        top: '177px',
        height: 'calc(100vh - 238px)',
        overflow: 'auto',
      }}
      {...rest}
    />
  );
}
